module.exports = __webpack_public_path__ + "static/media/exclamation.607cd57c.svg";